import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Compass, Search } from 'lucide-react';
import Footer from '../Footer';
import './NotFound.css';

// Recovery links shown below the primary "Back to homepage" action.
// "Contact" points at the footer's contact details (rendered on this same
// page) rather than a dedicated /contact route, since none exists in App.js.
const RECOVERY_LINKS = [
  { label: 'Universities', to: '/universities' },
  { label: 'Programs', to: '/programs' },
  { label: 'Scholarships', to: '/scholarships' },
  { label: 'Blog', to: '/blog' },
];

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [query, setQuery] = useState('');
  const attemptedUrl = `${location.pathname}${location.search}${location.hash}`;

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const trimmed = query.trim();
    // ProgramSearch (src/components/pages/ProgramSearch.js) is the only page
    // that reads a free-text `search` param — SearchResults.js does not — so
    // route there rather than adding q-param support to SearchResults.
    navigate(trimmed ? `/programs?search=${encodeURIComponent(trimmed)}` : '/programs');
  };

  return (
    <div className="not-found-page">
      <div className="not-found-main">
        <div className="not-found-card">
          <Compass className="not-found-icon" aria-hidden="true" size={48} />
          <h1>Page not found</h1>
          <p className="not-found-message">
            We couldn't find the page you were looking for. It may have moved,
            or the link might be out of date — let's get you back on track.
          </p>
          <p className="not-found-url">
            You tried to visit: <code>{attemptedUrl}</code>
          </p>

          <Link to="/" className="not-found-primary-btn">
            Back to homepage
          </Link>

          <nav className="not-found-links" aria-label="Helpful links">
            <ul>
              {RECOVERY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
              <li>
                <a href="#site-footer">Contact</a>
              </li>
            </ul>
          </nav>

          <form className="not-found-search" onSubmit={handleSearchSubmit} role="search">
            <label htmlFor="not-found-search-input">Search programs</label>
            <div className="not-found-search-row">
              <input
                id="not-found-search-input"
                type="search"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="e.g., Engineering, Business"
              />
              <button type="submit" aria-label="Search">
                <Search size={18} aria-hidden="true" />
                <span>Search</span>
              </button>
            </div>
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
